module.exports = __webpack_public_path__ + "static/media/ProductPurchase.440172cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/ProductPurchase.jpg
// module id = 3757
// module chunks = 0